import Button from "../components/Button";
import Image from "next/image";
import { useIsDesktop } from "../hooks/useIsDesktop";
import { useEffect, useState } from "react";
import { urlFor } from "../lib/sanityImage";

export default function HeroSection({ content }) {
  const {
    title,
    body,
    ctaLabel,
    ctaLink,
    imageDesktop,
    imageMobile = {},
  } = content;

  const desktopImage = imageDesktop?.asset
    ? urlFor(imageDesktop).quality(75).url()
    : "/images/hero-desktop.jpg";
  const mobileImage = imageMobile?.asset
    ? urlFor(imageMobile).quality(75).url()
    : "/images/hero-mobile.jpg";
  //const isDesktop = useIsDesktop();

  function useHasMounted() {
    const [hasMounted, setHasMounted] = useState(false);
    useEffect(() => setHasMounted(true), []);
    return hasMounted;
  }

  const hasMounted = useHasMounted();

  return (
    <div className="relative w-full h-[50vh] md:h-[640px] xl:h-[720px] xxl:h-[800px] overflow-hidden bg-brand-secondary">
      {/* Mobile image */}
      <Image
        src={mobileImage}
        alt=""
        fill
        priority
        sizes="(max-width: 767px) 100vw"
        className="block md:hidden lg:hidden object-cover"
      />

      {/* Desktop image */}
      <Image
        src={desktopImage}
        alt=""
        fill
        sizes="(min-width: 768px) 100vw"
        className="hidden md:block object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 flex items-end justify-center px-4 sm:px-8 pb-6 md:pb-12 page-width">
        <div className="text-center text-white max-w-2xl">
          {title && (
            <h1 className="text-3xl sm:text-5xl font-bold mb-1 md:mb-4">
              {title}
            </h1>
          )}
          {body && <p className="mb-4 text-lg sm:text-xl">{body}</p>}
          {ctaLabel && ctaLink && (
            <div className="hidden sm:inline-block mt-2">
              <Button size="large" href={ctaLink}>
                {ctaLabel}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
